import React from 'react'

const WhatsAppManager = () => {
  return (
    <div>WhatsappManager</div>
  )
}

export default WhatsAppManager